import { INITIALIZE_COMPONENT, SET_ERROR, LOCALIZED_INPUT } from './types';

const reducer = (state, action) => {
  switch (action.type) {
    case INITIALIZE_COMPONENT: return ({ error: false, data: action.component });
    case LOCALIZED_INPUT: return ({ ...state, data: { ...state.data, [action.name]: { ...state.data[action.name], [action.language]: action.value } } });
    case SET_ERROR: return ({ ...state, error: true });
    default: return ({ ...state, data: { ...state.data, [action.name]: action.value } });
  }
};

export default reducer;
